var map = {
	"./img_0.png": 207,
	"./img_1.png": 208,
	"./img_2.png": 209,
	"./img_3.png": 210,
	"./img_4.png": 211,
	"./img_5.png": 212,
	"./img_6.png": 213,
	"./img_7.png": 214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;